const TStrings = {
    EDIT_TEMPLATE_BUTTON: 'EDIT',
    SAVE_TEMPLATE_BUTTON: 'Save View',
    SAVING_TEMPLATE_BUTTON: 'Saving...',
    EXPORT_CSV_TEMPLATE_BUTTON: 'Export to CSV',
    CHECKBOX_ITEM_NAME_PLURAL_DESCRIPTOR: 'forms',
    FORMS_SELECT_TITLE: 'FORMS',
};

export default TStrings;
